var L = Object.defineProperty;
var _ = (e, r, t) => r in e ? L(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t;
var $ = (e, r, t) => _(e, typeof r != "symbol" ? r + "" : r, t);
function v(e) {
  return e != null && typeof e.hydrate == "function" && typeof e.toJSON == "function";
}
function b(e) {
  return Symbol(e);
}
function R(e, r) {
  for (const t of e) {
    const n = r(t);
    if (n !== void 0)
      return n;
  }
}
function te() {
  const e = /* @__PURE__ */ new Map(), r = [];
  return {
    set(t, n) {
      if (e.has(t))
        throw new Error(`Instance "${t.description}" is already registererd`);
      e.set(t, n());
    },
    get(t) {
      return e.get(t);
    },
    use(t) {
      if (r.includes(t))
        throw new Error(
          `Scenario "${t.displayName || t.id}" is already registered`
        );
      r.push(t);
    },
    matchRoute(t) {
      return R(r, (n) => n.matchRoute(t));
    },
    matchError(t) {
      return R(r, (n) => n.matchError(t));
    },
    matchDeeplink(t) {
      return R(r, (n) => n.matchDeeplink(t));
    },
    matchWidget(t) {
      return R(r, (n) => n.matchWidget(t));
    },
    toJSON() {
      const t = {};
      return e.forEach((n, o) => {
        v(n) && (t[o.toString()] = n.toJSON());
      }), t;
    },
    hydrate(t) {
      e.forEach((n, o) => {
        if (!v(n))
          return;
        const i = t[o.toString()];
        i != null && n.hydrate(i);
      });
    }
  };
}
var w = 256, C = [], D = 256, P;
for (; w--; ) C[w] = (w + 256).toString(16).substring(1);
function y(e) {
  var r = 0, t = 11;
  if (!P || w + t > D * 2)
    for (P = "", w = 0; r < D; r++)
      P += C[Math.random() * 256 | 0];
  return P.substring(w, w++ + t);
}
const M = Symbol("registered");
function J(e) {
  Object.defineProperty(e, M, {
    value: !0
  });
}
function x(e) {
  Object.defineProperty(e, "registered", {
    get() {
      return Object.prototype.hasOwnProperty.call(e, M);
    }
  });
}
function re(e) {
  const r = {}, t = {}, n = [], o = [], i = {
    addDeeplink(s) {
      n.push(s);
    },
    addError(s) {
      o.push(s);
    },
    addRoute(s) {
      const u = s.route;
      if (u.registered || u.id in r)
        throw new Error(`Route "${u.name}" is already registered`);
      J(u), r[u.id] = s;
    },
    addWidget(s) {
      const u = s.widget;
      if (u.registered || u.id in t)
        throw new Error(`Widget "${u.name}" is already registered`);
      J(u), t[u.id] = s;
    }
  }, a = y(), f = {
    get id() {
      return a;
    },
    get name() {
      return f.displayName ?? `scenario(${a})`;
    },
    init() {
      e(i);
    },
    matchError(s) {
      for (const u of o)
        if (u.is(s))
          return u;
    },
    matchRoute(s) {
      return r[s.id];
    },
    matchDeeplink(s) {
      for (const u of n) {
        const h = u.parse(s);
        if (h)
          return h;
      }
    },
    matchWidget(s) {
      return t[s.id];
    }
  };
  return f.init(), f;
}
function A(e = {}) {
  const r = y(), t = (...n) => ({
    id: r,
    params: n[0] ?? null,
    state: n[1] ?? null
  });
  return x(t), Object.defineProperties(t, {
    id: {
      get() {
        return r;
      }
    },
    name: {
      get() {
        return t.displayName ?? `route(${r})`;
      }
    },
    is: {
      value: (n) => n.id === r
    },
    key: {
      value: (n) => e.key ? `${r}:${e.key(n)}` : r
    }
  });
}
function ne(e = {}) {
  return A(e);
}
function oe() {
  const e = y(), r = {};
  return x(r), Object.defineProperties(r, {
    id: {
      get() {
        return e;
      }
    },
    name: {
      get() {
        return r.displayName ?? `widget(${e})`;
      }
    }
  });
}
class G extends Error {
  static is(r) {
    return r instanceof Error && r.name === this.name;
  }
  constructor(r) {
    super(r), this.name = this.constructor.name, typeof Error.captureStackTrace < "u" && Error.captureStackTrace(this, this.constructor);
  }
  toJSON() {
    return {
      name: this.name,
      message: this.message
    };
  }
}
class m extends G {
  constructor(r = "") {
    super(`Route is not found: "${r}"`);
  }
}
$(m, "name", "RouteNotFoundError");
function ie(e, r) {
  if (e.id !== r.id)
    return !1;
  for (const t in e.params)
    if (e.params[t] !== r.params[t])
      return !1;
  return !0;
}
function W(e) {
  var r, t;
  return (r = e == null ? void 0 : e.searchParams) != null && r.size ? `?${(t = e == null ? void 0 : e.searchParams) == null ? void 0 : t.toString()}` : "";
}
function F(e) {
  return e === "/" ? "" : e.replace(/^\/+/, "");
}
function N(e) {
  return e === "/" ? "" : e.replace(/\/+$/, "");
}
function ae(e) {
  let r = e != null && e.basename ? N(e.basename) : "";
  const t = [], n = {};
  let o = [], i = [], a = !1, f = y(), s = 0, u;
  const h = (c) => {
    if (r) {
      if (!c.startsWith(r))
        throw new m(c);
      c = c.slice(r.length);
    }
    c = N(c) || "/";
    for (const d of t) {
      const l = n[d];
      if (!l)
        continue;
      const g = l.path.match(c);
      if (g)
        return l.route(g);
    }
    throw new m(c);
  }, S = (c, d) => {
    let l = 0;
    const g = () => {
      if (!u)
        return;
      const E = i[l++];
      if (E)
        E(u, c, g);
      else {
        const { route: k } = n[c.id];
        f = e != null && e.enableRouteKey ? k.key(c.params) : y(), u = c, s = d, o.forEach((H) => H());
      }
    };
    g();
  }, p = typeof window < "u" ? window.history : {};
  return {
    get basename() {
      return r;
    },
    get action() {
      return s;
    },
    get key() {
      return f;
    },
    get location() {
      if (!u)
        throw new m();
      return u;
    },
    get length() {
      return p.length;
    },
    ref() {
      return T;
    },
    add(c, d) {
      if (d.id in n)
        throw new Error(`Route "${d.id}" is already existed`);
      return t.push(d.id), n[d.id] = { path: c, route: d }, this;
    },
    go(c) {
      p.go(c);
    },
    back() {
      p.go(-1);
    },
    forward() {
      p.go(1);
    },
    navigate({ to: c, basename: d, replace: l, meta: g }) {
      d && (r = N(d));
      const E = this.serialize(c) + W(g);
      try {
        l ? p.replaceState(c.state, "", E) : p.pushState(c.state, "", E), S(
          c,
          l ? 2 : 1
          /* PUSH */
        );
      } catch {
        window.location.assign(E);
      }
    },
    run(c) {
      return a ? this : (a = !0, s = 0, u = h(c), typeof window < "u" && window.addEventListener("popstate", () => {
        try {
          const d = h(window.location.pathname);
          S(
            d,
            0
            /* POP */
          );
        } catch (d) {
          d instanceof m && window.location.reload();
        }
      }), this);
    },
    serialize(c) {
      const d = n[c.id];
      if (d) {
        const l = d.path.format(c.params);
        return `${r}/${F(l)}`;
      }
      return r;
    },
    listen(c) {
      return o.push(c), () => {
        o = o.filter((d) => d !== c);
      };
    },
    beforeEach(c) {
      return i.push(c), () => {
        i = i.filter((d) => d !== c);
      };
    }
  };
}
const T = b("Router"), U = /[\-{}\[\]+?.,\\\^$|#\s]/g, X = /:(\w+)(\\?)?/g, j = /:(\w+)(\?)?/g, z = /\/+/g, K = (e) => e === "true" || e === "1", B = (e) => {
  const r = Number(e);
  if (!isFinite(r) && !isNaN(r))
    return r;
}, Q = String, se = {
  boolean: K,
  number: B,
  string: Q
};
function ue(e, r) {
  const t = [], n = e.replace(U, "\\$&").replace(X, (i, a, f) => {
    if (!(r != null && r.hasOwnProperty(a)))
      throw new Error(`Missing parsing rule for param "${a}"`);
    return t.push({
      name: a,
      optional: !!f,
      parse: r[a]
    }), "([^/?]+)";
  }), o = new RegExp("^" + n + "(?:\\?([\\s\\S]*))?$");
  return {
    get path() {
      return e;
    },
    match(i) {
      const a = i.match(o);
      if (a) {
        let f = 1;
        return t.reduce((s, u) => {
          const h = a[f++];
          if (h != null) {
            const S = u.parse(h);
            s[u.name] = S;
          }
          return s;
        }, {});
      }
    },
    format(i) {
      return e.replace(j, (a, f, s) => {
        const u = i[f];
        if (u === void 0 && !s)
          throw new Error(`Invalid path params: "${f}"`);
        return encodeURIComponent(u);
      }).replace(z, "/");
    }
  };
}
function ce(e = {}) {
  return {
    get(r, t, n) {
      const o = e[r];
      if (t !== void 0 && o === void 0)
        return n;
      if (t === "number") {
        const i = Number(o);
        return !isNaN(i) && isFinite(i) ? i : n;
      }
      return t === "boolean" ? o === "true" || o === "1" || !!o : t === "string" ? String(o) : o;
    },
    toJSON() {
      return e;
    }
  };
}
function V(e) {
  return typeof e == "function";
}
function I(e) {
  let r = e, t = [];
  const n = {
    refs() {
      return t.length;
    },
    get() {
      return r;
    },
    listen(o) {
      return t.push(o), () => {
        t = t.filter((i) => i !== o);
      };
    }
  };
  return {
    ...n,
    seal() {
      return n;
    },
    set(o) {
      const i = V(o) ? o(r) : o;
      i !== r && (r = i, t.forEach((a) => a()));
    }
  };
}
function fe(e) {
  let r = e.locales;
  const t = I(e.defaultLocale);
  function n() {
    if (typeof window < "u") {
      const o = t.get();
      document.documentElement.lang = o.lang, document.documentElement.dir = o.dir;
    }
  }
  return {
    locale: t.seal(),
    get locales() {
      return r;
    },
    ref() {
      return Y;
    },
    resolve(o) {
      return r.find((i) => i.lang === o);
    },
    switch(o) {
      const i = this.resolve(o);
      i && (t.set(i), n());
    },
    toJSON() {
      return {
        locale: t.get(),
        locales: r
      };
    },
    hydrate(o) {
      r = o.locales, t.set(o.locale);
    }
  };
}
const Y = b("I18n");
var O = /* @__PURE__ */ ((e) => (e[e.IDLE = 0] = "IDLE", e[e.PENDING = 1] = "PENDING", e[e.ERROR = 2] = "ERROR", e[e.SUCCESS = 3] = "SUCCESS", e))(O || {});
function Z(e) {
  let r, t, n, o = 0;
  const i = I(Date.now());
  return {
    get status() {
      return o;
    },
    get data() {
      return t;
    },
    updated: i.seal(),
    read() {
      if (o === 0 && (r = e.fetch().then((a) => {
        o = 3, t = a, i.set(Date.now());
      }).catch((a) => {
        o = 2, n = a;
      }), o = 1), o === 1)
        throw r;
      if (o === 2)
        throw n;
      return t;
    },
    expired(a) {
      return e.lifetime < 0 ? !1 : i.get() + e.lifetime < a;
    },
    unused() {
      return i.refs() === 0;
    },
    toJSON() {
      var a;
      return (a = e.toJSON) == null ? void 0 : a.call(e, t);
    },
    hydrate(a) {
      var s;
      const f = (s = e.hydrate) == null ? void 0 : s.call(e, a);
      f && (t = f, o = 3);
    },
    update(a) {
      a !== t && (t = a, o = 3, i.set(Date.now()));
    }
  };
}
function de() {
  const e = /* @__PURE__ */ new Map();
  let r;
  return {
    ref() {
      return q;
    },
    find(t) {
      return e.get(t);
    },
    acquire(t) {
      return t.map((n) => {
        if (!e.has(n.key)) {
          const o = Z(n.params);
          if (r) {
            const i = r[n.key];
            i && o.hydrate(i);
          }
          e.set(n.key, o);
        }
        return n.key;
      });
    },
    read(t) {
      const n = [], o = t.map((i) => {
        const a = e.get(i);
        if (!a)
          throw new Error(`Resource "${i}" is not found`);
        try {
          return a.read();
        } catch (f) {
          if (f instanceof Promise)
            n.push(f);
          else
            throw f;
        }
      });
      if (n.length)
        throw Promise.all(n);
      return o;
    },
    listen(t, n) {
      const o = [];
      return t.forEach((i) => {
        const a = e.get(i);
        a && o.push(a.updated.listen(n));
      }), () => {
        o.forEach((i) => i());
      };
    },
    free() {
      const t = Date.now();
      e.forEach((n, o) => {
        (n.expired(t) || n.status === O.ERROR) && n.unused() && e.delete(o);
      });
    },
    toJSON() {
      const t = {}, n = Date.now();
      return e.forEach((o, i) => {
        if (o.expired(n))
          return;
        const a = o.toJSON();
        a && (t[i] = a);
      }), t;
    },
    hydrate(t) {
      r = t;
    }
  };
}
const q = b("Resources");
function le(e) {
  const { toJSON: r, hydrate: t } = e;
  return (n, o) => {
    const i = e.key(n), a = {
      fetch: () => e.fetch(n),
      lifetime: (o == null ? void 0 : o.lifetime) ?? -1
    };
    return r && (a.toJSON = (f) => r(f, n)), t && (a.hydrate = (f) => t(f, n)), {
      key: i,
      params: a
    };
  };
}
function he(e) {
  const { toJSON: r, hydrate: t } = e;
  return (n, { pagination: o, lifetime: i = -1 }) => {
    const a = e.key(n), f = {
      fetch: (s) => {
        const u = e.nextPageInfo(s);
        return e.fetch(n, s, u);
      },
      lifetime: i
    };
    return r && (f.toJSON = (s) => r(s, n)), t && (f.hydrate = (s) => t(s, n)), o.attach(a, {
      fetch: (s, u) => e.fetch(n, s, u),
      nextPageInfo: e.nextPageInfo
    }), {
      key: a,
      params: f
    };
  };
}
function ge(e) {
  const r = I("idle");
  let t, n, o = !1;
  return {
    status: r.seal(),
    attach(i, a) {
      if (t && i !== t)
        throw new Error("Infinite pagination is already attached to another rosource");
      t = i, n = a;
    },
    fetch() {
      if (!t || !n)
        throw new Error("Infinite pagination is not attached to any resource");
      if (r.get() === "loading")
        return;
      const i = e.find(t);
      if (!i || i.status !== O.SUCCESS)
        return;
      const a = i.data, f = n.nextPageInfo(a);
      f !== void 0 && (r.set("loading"), n.fetch(a, f).then((s) => {
        o || (r.set("idle"), i.update(s));
      }).catch(() => {
        o || r.set("error");
      }));
    },
    effect() {
      return o = !1, () => {
        o = !0;
      };
    }
  };
}
export {
  G as CustomError,
  se as PathParam,
  m as RouteNotFoundError,
  ue as compilePath,
  te as createApplicationManager,
  ce as createFlags,
  fe as createI18nManager,
  ge as createInfinitePagination,
  he as createInfiniteQuery,
  A as createMetaRoute,
  b as createRef,
  le as createResourceQuery,
  de as createResources,
  ne as createRoute,
  ae as createRouter,
  re as createScenario,
  I as createSignal,
  oe as createWidget,
  ie as equalsLocation,
  Y as i18nRef,
  q as resourcesRef,
  T as routerRef
};
